import { SeededRng } from '@/core/rng';

/** Prefix of the per-line "already read" marks persisted in StoryState.marks (and therefore in saves). */
export const READ_MARK_PREFIX = 'read:';

/** Stable, short, deterministic hash of a line's text (base36 of the project string hash). */
export function textHash(text: string): string {
  return SeededRng.hash(text).toString(36);
}

/** Mark id that records a line of dialogue as read: `read:<hash>`. */
export function readMarkFor(text: string): string {
  return READ_MARK_PREFIX + textHash(text);
}

export function isReadMark(mark: string): boolean {
  return mark.startsWith(READ_MARK_PREFIX);
}
